import { rtkAPI } from 'rtk/rtkSetup';
import api from 'util/api';
import enums from 'util/enums';

const enhancedApi = rtkAPI.enhanceEndpoints({
  addTagTypes: ['DocType']
});

export const docTypeApi = enhancedApi.injectEndpoints({
  endpoints: build => ({
    enumerateDocTypes: build.query({
      async queryFn(args) {
        const {
          skip = 0,
          keyword = '',
          sortKey = 'Created',
          sortOrderAsc = false,
          pageSize = 25
        } = args || {};

        const trimmedKeyword = (keyword || '').trim();
        const effectiveSortKey = sortKey === 'IsFavorite' ? 'Created' : sortKey;
        const orderDirection = sortOrderAsc ? 'asc' : 'desc';

        const body = {
          MaxResults: pageSize,
          Skip: skip,
          OrderBy: effectiveSortKey,
          OrderDirection: orderDirection,
          IncludeData: false,
          IncludeSubordinates: false,
          ...(trimmedKeyword.length > 0 && { Text: trimmedKeyword }),
          Filters: {
            ...(sortKey === 'IsFavorite' && { IsFavorite: 1 })
          }
        };

        try {
          const res = await api.Enumeration(
            enums.ENUMERATION_TYPES.DOCTYPE,
            body
          );
          return { data: res };
        } catch (error) {
          return { error };
        }
      },
      keepUnusedDataFor: 60,
      providesTags: [{ type: 'DocType', id: 'LIST' }]
    })
  })
});

export const { useEnumerateDocTypesQuery } = docTypeApi;
